import { z } from "zod";
import {
  confidenceSchema,
  isoDateTimeSchema,
  nonEmptyStringSchema,
  uuidSchema,
} from "../primitives.js";

export const claimSchema = z.object({
  id: uuidSchema,
  hotel_id: uuidSchema,
  field: nonEmptyStringSchema,
  value_json: z.unknown(),
  confidence: confidenceSchema,
  /** Required — claims without a source are invalid */
  source_url: z.string().url(),
  source_artifact_id: uuidSchema.nullable(),
  observed_at: isoDateTimeSchema,
  created_at: isoDateTimeSchema,
  research_job_id: uuidSchema.nullable(),
  agent_run_id: uuidSchema.nullable(),
});

export type Claim = z.infer<typeof claimSchema>;

/** Payload for save_claims — source_url required per claim */
export const claimInputSchema = z.object({
  field: nonEmptyStringSchema,
  value: z.unknown(),
  confidence: confidenceSchema,
  source_url: z.string().url(),
  source_artifact_id: uuidSchema.optional().nullable(),
  observed_at: isoDateTimeSchema.optional(),
});

export type ClaimInput = z.infer<typeof claimInputSchema>;

export const saveClaimsInputSchema = z.object({
  hotel_id: uuidSchema,
  claims: z.array(claimInputSchema).min(1),
  research_job_id: uuidSchema.optional(),
  agent_run_id: uuidSchema.optional(),
});

export type SaveClaimsInput = z.infer<typeof saveClaimsInputSchema>;
